import { TradersPage } from 'features/traders';

export const AdminTradersPage: React.FC = () => <TradersPage />;
